import React, { useMemo } from 'react';
import Head from 'next/head';
import getProductSchema from 'cards/pages/ProductDetail/helper';
import { SETTINGS_BY_CARD_TYPE } from 'cards/constants/CardTypes';

type DataPerColor = {
  imgs: string[];
  colors: string[];
};

type Color = {
  plp_front_image_url: string;
  label: string;
};

type Product = {
  name: string;
  description: string;
  suiteUUID: string;
  min_price_cents: number;
  colors: Color[];
};

type SEOSchemaProps = {
  products: Product[];
  baseUrl: string;
  cardType: string;
  isDigital: boolean;
};

const SEOSchema = ({
  products = [],
  baseUrl = '',
  cardType = '',
  isDigital,
}: SEOSchemaProps): JSX.Element => {
  const stringifiedContent = useMemo(() => {
    const getJsonProductSchema = products.map(product => {
      const itemPrice = (product?.min_price_cents / 100).toFixed(2);
      const itemDataPerColor = product?.colors.reduce(
        (acc: DataPerColor, color: Color) => {
          acc.imgs.push(color.plp_front_image_url);
          acc.colors.push(color.label);
          return acc;
        },
        { imgs: [], colors: [] }
      );

      return getProductSchema({
        itemName: product?.name,
        itemImgUrlPerColor: itemDataPerColor?.imgs,
        itemColors: itemDataPerColor?.colors,
        itemDescription: product?.description,
        itemSku: product?.suiteUUID,
        itemUrl: `${isDigital ? `${baseUrl}/digital` : `${baseUrl}`}/${
          SETTINGS_BY_CARD_TYPE[cardType].urlSlug
        }/${product?.suiteUUID}`,
        itemPrice,
      });
    });
    return JSON.stringify(getJsonProductSchema);
  }, [products, baseUrl, cardType]);

  return (
    <Head>
      <script type="application/ld+json" key="cardPlpProductsSchema">
        {stringifiedContent}
      </script>
    </Head>
  );
};

export default SEOSchema;
